import { useEffect } from 'react';
import { useNativeApp } from '@/lib/hooks/use-native-app';
import { updateUserProfile, setUserIdentity, trackEvent, initializeSmartechBaseReact } from '@/lib/utils/netcore';
import type { NetcoreUserProfile } from '@/lib/utils/netcore';

export default function NetcoreHandler() {
  const { isNativeApp, isReady } = useNativeApp();

  useEffect(() => {
    // Initialize SmartechBaseReact interface for native app
    initializeSmartechBaseReact();

    if (!isReady) {
      return;
    }

    // Handle messages from native app via postMessage
    const handlePostMessage = (event: MessageEvent) => {
      try {
        if (typeof event.data !== 'string') {
          return;
        }

        const data = JSON.parse(event.data);

        if (data.type === 'UPDATE_USER_PROFILE' && data.userProfile) {
          updateUserProfile(data.userProfile as NetcoreUserProfile);
        }

        if (data.type === 'SET_USER_IDENTITY' && data.userIdentity) {
          setUserIdentity(data.userIdentity);
        }

        if (data.type === 'TRACK_EVENT' && data.eventName) {
          trackEvent(data.eventName, data.eventPayload);
        }
      } catch (error) {
        // Ignore non-JSON messages or parsing errors
      }
    };

    // Listen for postMessage from ReactNativeWebView
    if (isNativeApp) {
      window.addEventListener('message', handlePostMessage);
    }

    return () => {
      if (isNativeApp) {
        window.removeEventListener('message', handlePostMessage);
      }
    };
  }, [isReady, isNativeApp]);

  // This component doesn't render anything
  return null;
}


